import { render, staticRenderFns } from "./SmsInstance.vue?vue&type=template&id=4b5b4dc7&scoped=true&"
import script from "./SmsInstance.vue?vue&type=script&lang=js&"
export * from "./SmsInstance.vue?vue&type=script&lang=js&"
import style0 from "./SmsInstance.vue?vue&type=style&index=0&id=4b5b4dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b4dc7",
  null
  
)

export default component.exports